<template>
  <span :data-id="nodo_id">
    <ruta v-if="padre_id !== null" :nodos="nodos" :nodo_id="padre_id" @ir_al_padre="(valor) => $emit('ir_al_padre', valor)" :data-id="nodo_id"></ruta> 
    <!--span v-if="nodo_id != 1"> / </span--> 

    <feather-icon style="width: 18px;margin: 0px 7px;" icon="ChevronsRightIcon" v-if="nodo_id != 1" size="small"/>

    <span v-if="nodo_id == 1" @click.prevent="ir_home" :data-id="nodo_id">
      <feather-icon icon="HomeIcon" size="small" style="color: #00984a; cursor: pointer" :data-id="nodo_id" />
    </span>
    <span v-else @click.prevent="ir" :data-id="nodo_id" style="vertical-align: top; color: #00984a; cursor: pointer">{{titulo}}</span>
    
  </span>
</template>

<script>
//import JQuery from 'jquery'
//let $ = JQuery
import vSelect from 'vue-select'

export default {
  name:"ruta",
  data() {
    return {
      visible: false
    }
  },
  props: {
    nodos: Array,
    nodo_id: Number
  },
  computed: {
    titulo: function(){
      var nodoss = this.nodos.filter(nodo => {
        if(nodo.id == this.nodo_id)
          return true
        else
          return false
      })
      if(nodoss.length > 0)
        return nodoss[0].titulo
      else
        return ''
    },
    padre_id: function(){
      var nodoss = this.nodos.filter(nodo => {
        if(nodo.id == this.nodo_id)
          return true
        else
          return false
      })
      if(nodoss.length > 0){
        return nodoss[0].nodo_id
      }else{
        return null
      }
    }
  },
  mounted(){

  },
  methods: {
    ir_home(){
      this.$emit('ir_al_padre',1)  
    },
    ir(event){
      var valor = 0
      if(typeof event.target !== undefined){
        valor = event.target.getAttribute('data-id')
      } 
      this.$emit('ir_al_padre',valor)       
    }
  },
  components: {
    'v-select': vSelect,
  }
}
</script>

